// extracted by mini-css-extract-plugin
export var triSplit = "trisplit-module--tri-split--4e8f4";
export var triSplitItem = "trisplit-module--tri-split-item--26ac5";
export var triSplitWrapper = "trisplit-module--tri-split-wrapper--6e248";